package com.partejar.app.feature.planos.data

data class Plano(
    val id: Long,
    val name: String,
    val currentPrice: Double,
    val active: Boolean,
    val services: List<String>
)

data class PlanoInput(
    val name: String,
    val currentPrice: Double,
    val active: Boolean,
    val services: List<String>
)

interface PlanosDataSource {
    suspend fun list(): List<Plano>
    suspend fun create(input: PlanoInput): Plano
    suspend fun update(planId: Long, input: PlanoInput): Plano
}

open class PlanosDataException(cause: Throwable? = null) : Exception(cause)
class PlanosAccessException : PlanosDataException()
class PlanosUnavailableException(cause: Throwable? = null) : PlanosDataException(cause)
